import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_30_receipt_vouchers: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    screenId: "30",
    fabAction: {
      type: "add",
      screenId: "10",
      permissionKey: "Add",
      action: "navigate_modulev1/invoice_receivables",
    },
    title: "Receipt vouchers",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "name",
            Name: "receivables_summary",
            BindValue: "grid_purchase",
            SummeryActions: [
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Settings: "customer_paid_amount_splitup",
                },
                tooltip: "View",
              },
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Settings: "customer_statementof_accounts",
                },
                tooltip: "Statement of accounts",
              },
            ],
            Form: {
              Name: "receivables_summary",
              TableName: "",
              View: "view_recevibales_summary",
              DisplayName: "receivables_summary",
              CheckBranch: true,
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer name",
                  BindValue: "suppliername",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer address",
                  BindValue: "address",
                  Json_Attribute: "address",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Ledger Balance",
                  BindValue: "amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Total due amount",
                  BindValue: "total_due_amount",
                  Json_Attribute: "total_due_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

